
















import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { TeacherData } from '@/mixins/requests/admin/TeacherListApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class TeacherTable extends Vue {
  @Prop()
  private teacherList!: TeacherData[]
  @Prop()
  private onClickEdit!: (teacherId: string) => void
  @Prop()
  private onClickDelete!: (userId: string) => void
}
